<template>
  <section>
    <v-container>
      <v-card>
        <v-card-text>
          <v-layout
            row
            wrap>
            <v-flex
              md10
              pt-2>
              <label>
                Will DXC be providing "Root Access" to the AWS credentials? (Default is No)
              </label>
            </v-flex>
            <v-flex
              xs12
              sm12
              md2
              xl2>
              <v-layout
                column
                align-end>
                <v-flex>
                  <v-btn-toggle v-model="newWorkload.wlqa.WL_Q1A">
                    <v-btn
                      :class="{ 'v-btn--active': newWorkload.wlqa.WL_Q1A === 'Y' } "
                      class="black--text btn--qa"
                      value="Y"
                      disabled
                    >Yes</v-btn>
                    <v-btn
                      :class="{ 'v-btn--active':newWorkload.wlqa.WL_Q1A === 'N' }"
                      value="N"
                      class="black--text btn--qa"
                      disabled
                    >No</v-btn>
                  </v-btn-toggle>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>

          <v-layout
            row
            wrap>
            <v-flex
              md10
              pt-2>
              <label>
                Does this opportunity include DXC Managed Services?
              </label>
            </v-flex>
            <v-flex
              xs12
              sm12
              md2
              xl2>
              <v-layout
                column
                align-end>
                <v-flex>
                  <v-btn-toggle v-model="newWorkload.wlqa.WL_Q2A">
                    <v-btn
                      :class="{ 'v-btn--active': newWorkload.wlqa.WL_Q2A === 'Y' }"
                      class="black--text btn--qa"
                      value="Y"
                      disabled
                    >Yes</v-btn>
                    <v-btn
                      :class="{ 'v-btn--active':newWorkload.wlqa.WL_Q2A === 'N' }"
                      value="N"
                      class="black--text btn--qa"
                      disabled
                    >No</v-btn>
                  </v-btn-toggle>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>

          <v-layout
            row
            wrap>
            <v-flex
              md10
              pt-2>
              <label>
                Is this a DXC SaaS-delivered solution?
              </label>
            </v-flex>
            <v-flex
              xs12
              sm12
              md2
              xl2>
              <v-layout
                column
                align-end>
                <v-flex>
                  <v-btn-toggle v-model="newWorkload.wlqa.WL_Q3A">
                    <v-btn
                      :class="{ 'v-btn--active': newWorkload.wlqa.WL_Q3A === 'Y' }"
                      class="black--text btn--qa"
                      value="Y"
                      disabled
                    >Yes</v-btn>
                    <v-btn
                      :class="{ 'v-btn--active':newWorkload.wlqa.WL_Q3A === 'N' }"
                      value="N"
                      class="black--text btn--qa"
                      disabled
                    >No</v-btn>
                  </v-btn-toggle>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>

          <v-layout
            row
            wrap>
            <v-flex
              md10
              pt-2>
              <label>
                Are there any workloads identified in the project description that are currently running on AWS?
                <span
                  class="required"
                />
              </label>
            </v-flex>
            <v-flex
              xs12
              sm12
              md2
              xl2>
              <v-layout
                column
                align-end>
                <v-flex>
                  <v-btn-toggle v-model="newWorkload.wlqa.WL_Q4A">
                    <v-btn
                      :class="{ 'v-btn--active': newWorkload.wlqa.WL_Q4A === 'Y' }"
                      class="black--text btn--qa"
                      disabled
                      value="Y"
                    >Yes</v-btn>
                    <v-btn
                      :class="{ 'v-btn--active':newWorkload.wlqa.WL_Q4A === 'N' }"
                      value="N"
                      class="black--text btn--qa"
                      disabled
                    >No</v-btn>
                  </v-btn-toggle>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>

          <v-layout
            row
            wrap>
            <v-flex
              md10
              pt-2>
              <label>Are there any workloads identified in the project description that are new to AWS and were under DXC management on or before September 1, 2018?</label>
              <span class="required"/>
            </v-flex>
            <v-flex
              xs12
              sm12
              md2
              xl2>
              <v-layout
                column
                align-end>
                <v-flex>
                  <v-btn-toggle v-model="newWorkload.wlqa.WL_Q5A">
                    <v-btn
                      :class="{ 'v-btn--active': newWorkload.wlqa.WL_Q5A === 'Y' }"
                      class="black--text btn--qa"
                      value="Y"
                      disabled
                    >Yes</v-btn>
                    <v-btn
                      :class="{ 'v-btn--active':newWorkload.wlqa.WL_Q5A === 'N' }"
                      value="N"
                      class="black--text btn--qa"
                      disabled
                    >No</v-btn>
                  </v-btn-toggle>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>

          <v-layout
            row
            wrap>
            <v-flex
              md10
              pt-2>
              <label>Are there any workloads identified in the project description that are net-new to AWS and NOT under DXC management on or before September 1, 2018?</label>
              <span class="required"/>
            </v-flex>
            <v-flex
              xs12
              sm12
              md2
              xl2>
              <v-layout
                column
                align-end>
                <v-flex>
                  <v-btn-toggle v-model="newWorkload.wlqa.WL_Q6A">
                    <v-btn
                      :class="{ 'v-btn--active': newWorkload.wlqa.WL_Q6A === 'Y' }"
                      class="black--text btn--qa"
                      value="Y"
                      disabled
                    >Yes</v-btn>
                    <v-btn
                      :class="{ 'v-btn--active':newWorkload.wlqa.WL_Q6A === 'N' }"
                      value="N"
                      class="black--text btn--qa"
                      disabled
                    >No</v-btn>
                  </v-btn-toggle>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
      <v-layout row>
        <v-layout
          column
          align-center>
          <v-flex
            xs12
            sm12
            md12
            xl12>
            <div style="margin: 25px 0; padding:15px 0; font-size:48px">
              <h3>
                Workload Type:
                <span>{{ newWorkload.oppproject.Workload_type }}</span>
              </h3>
            </div>
          </v-flex>
        </v-layout>
      </v-layout>
    </v-container>
  </section>
</template>
<script>
import { mapState } from 'vuex'
export default {
  data () {
    return {}
  },
  computed: {
    ...mapState('admin/oppregAdmin', ['workload', 'newWorkload'])
  }
}
</script>
<style lang="scss" scoped>
.disable-events {
  pointer-events: none;
}

.v-btn-toggle {
  margin: 10px 0;
}
.v-btn-toggle .v-btn {
  padding: 15px 25px;
  opacity: 0.7px;
}
.btn--qa {
  font-weight: bold !important;
}
.v-btn--active:before,
.v-btn:focus:before,
.v-btn:hover:before {
  background-color: grey;;
}
</style>
